import React, { useRef, useState, useLayoutEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@mui/material/Popper";
import './InputAutoComplete.css'

const CustomPopper = (props) => {
  return (
    <Popper
      {...props}
      style={{
        ...props.style,
        width: props.anchorEl?.clientWidth,
        zIndex: 9999,
      }}
      placement="bottom-start"
    />
  );
};

export const InputAutoComplete = ({
  label = "",
  placeholder = "",
  options = [],
  value,
  error = "",
  onChange,
  getOptionLabel = (option) => option.label || "",
  filterFunction,
  name,
  fontSize = "14px",
  height = "auto",
  style = {},
  preventSubmitOnEnter = false,
  container = null, // Container para renderizar o dropdown
}) => {
  const inputRef = useRef(null);
  const [inputWidth, setInputWidth] = useState('auto');

  // Calculate width after component mounts and on window resize
  useLayoutEffect(() => {
    const calculateWidth = () => {
      if (inputRef.current) {
        const rect = inputRef.current.getBoundingClientRect();
        if (rect.width > 0) {
          setInputWidth(rect.width + 'px');
        }
      }
    };

    calculateWidth();
    window.addEventListener('resize', calculateWidth);

    return () => window.removeEventListener('resize', calculateWidth);
  }, []);

  const defaultFilter = (options, { inputValue }) => {
    const cleanText = (str) => {
      if (!str) return "";
      return str
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[.,\-\s]/g, "")
        .trim();
    };

    const cleanInputValue = cleanText(inputValue);

    return options.filter(
      (option) =>
        option &&
        getOptionLabel(option) &&
        cleanText(getOptionLabel(option)).includes(cleanInputValue)
    );
  };

  const getCustomPopper = (props) => {
    return (
      <Popper
        {...props}
        container={container}
        style={{
          ...props.style,
          width: inputWidth,
          zIndex: 9999,
        }}
        placement="bottom-start"
      />
    );
  };

  const handleKeyDown = (event) => {
    if (preventSubmitOnEnter && event.key === 'Enter') {
      // Prevent form submission on Enter
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <div className="autoCompleteInputWrapper" style={{ ...style }}>
      {label && (
        <label className="selectLabel" htmlFor={name}>
          {label}
        </label>
      )}
      <div className="auto-complete-wrapper" ref={inputRef}>
        <Autocomplete
          options={options}
          getOptionLabel={getOptionLabel}
          filterOptions={filterFunction || defaultFilter}
          fullWidth
          slots={{
            popper: getCustomPopper,
            paper: (props) => (
              <div
                {...props}
                style={{
                  ...props.style,
                  minWidth: inputWidth,
                  width: inputWidth,
                  maxWidth: inputWidth,
                }}
              />
            ),
          }}
          value={value}
          onChange={onChange}
          renderInput={(params) => (
            <div
              ref={params.InputProps.ref}
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              <input
                {...params.inputProps}
                placeholder={placeholder}
                className="autoComplete"
                id={name}
                onKeyDown={handleKeyDown}
                style={{
                  width: "100%",
                  fontSize: fontSize,
                  height: height,
                  ...(height !== "auto" && {
                    minHeight: height,
                    maxHeight: height,
                    padding: "0 20px",
                    boxSizing: "border-box"
                  })
                }}
              />
            </div>
          )}
          renderOption={(props, option, { selected }) => (
            <li
              {...Object.fromEntries(
                Object.entries(props).filter(([key]) => key !== "key")
              )}
              key={props.key}
              className="optionCustom"
              style={{
                backgroundColor: selected ? "#f0f0f0" : "#fff",
              }}
            >
              {getOptionLabel(option)}
            </li>
          )}
          noOptionsText="Nada encontrado"
        />
        {error && <p className="textError">{error}</p>}
      </div>
    </div>
  );
};
